/**
 * Vello corner-radius tokens (S055; IMPORT-0001 §3). Verbatim from `tokens/radius.css`.
 *
 * Inputs/buttons 8 · tiles 12 · cards/panels 16 · sheets/modals 24 · pill 999. `xs` (6) is for small
 * chips/square badges.
 *
 * Radius BY ROLE (D547): the web consoles (Admin Web A08) draw cards, lists, menus, KPI cards and toasts at 12 and
 * dialogs and the command palette at 16 — one step below the design-system card (16) and sheet (24). The roles name
 * that usage so a stylesheet asks for `--radius-card`, not for a step it has to guess. Also from A08: drawer KPI tiles /
 * rail tiles 10, small row buttons 7, the keyboard-hint chip and the checkbox 5, the photo modal 20.
 */
export const RADIUS = {
    xs: 6,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    pill: 999,
    /** Panels, KPI cards, lists, menus and toasts of the web consoles. */
    card: 12,
    list: 12,
    menu: 12,
    kpi: 12,
    toast: 12,
    /** The confirm/edit dialog and the command palette. */
    dialog: 16,
    palette: 16,
    /** Drawer KPI tiles and the icon-rail tiles. */
    tile: 10,
    /** The small row/toolbar buttons and the sign-out tile. */
    rowbtn: 7,
    /** The keyboard-hint chip. */
    kbd: 5,
    /** The checkbox square. */
    check: 5,
    /** The photo modal. */
    photo: 20,
};
//# sourceMappingURL=radius.js.map